
import store from '@/store';
import router from '@/router';
export class Utils {
    static formatMoney(number) {
       
        const numbWithComma = number.toFixed(2).replace(".",",");
        return  numbWithComma.replace(/./g, function(c, i, a) {
            return i > 0 && c !== "," && (a.length - i) % 3 === 0 ? "." + c : c;
        })+"€";
        
    }
    static couponStatus(status){
        if(status == 'Open'){
            return 0;
        }
        else if(status == 'Won'){
            return 1;
        }
        else if(status == 'Lost'){
            return 2;
        }
        else{
            return status;
        }
    }
    static buildListParams(key,page){
        
        const params = {
            pageNumber: page,
        };
        
        let buildQueryVariables = '?pageNumber='+page;
        const filters = store.getters.getFiltersMapping({key:key});
        
        const appliedFilters = store.state.DynamicFilterModule.appliedFilterValues[key];
        
        const parentID = store.state.DynamicListModule.parentID;
        const searchTerm = store.state.DynamicListModule.searchTerm;
        const sortBy = store.state.DynamicListModule.sortBy;
        const mapping = store.state.DynamicListModule.mapping;
       
        
        if (filters) {	
            filters.forEach((filter) => {
               
                if (appliedFilters) {
                    
                    
                    if (appliedFilters[filter.name]) {
                         if(appliedFilters[filter.name]['type']){
                            
                            if(appliedFilters[filter.name]['type'] == 'array'){
                                if (appliedFilters[filter.name]['value'] != ''  && appliedFilters[filter.name]['value']) {
                            
                          
                                    params[filter.nameToRequest] = [];
                                    for (let index = 0; index < appliedFilters[filter.name]['value'].length; index++) {
                                        params[filter.nameToRequest][index] = appliedFilters[filter.name]['value'][index];
                                        buildQueryVariables += '&' + filter.name + '=' + appliedFilters[filter.name]['value'][index];
                                        buildQueryVariables += '&' + filter.name + '_text=' + appliedFilters[filter.name]['valueText'][index];
                                    }
                                    
                                }
                                else{
                                    params[filter.nameToRequest] = appliedFilters[filter.name]['value'];
                                }
                            }
                            else if(appliedFilters[filter.name]['type'] == 'bool'){
                                params[filter.nameToRequest] = (appliedFilters[filter.name]['value']!=null)?appliedFilters[filter.name]['value']:null;
                                if(appliedFilters[filter.name]['value']!=null){
                                    buildQueryVariables += '&' + filter.name + '=' + appliedFilters[filter.name]['value'];
                                    buildQueryVariables += '&' + filter.name + '_text=' + appliedFilters[filter.name]['valueText'];
                                }
                                
                            }
                            else if(appliedFilters[filter.name]['type'] == 'radio'){
                                params[filter.nameToRequest] = (appliedFilters[filter.name]['value']!=null)?appliedFilters[filter.name]['value']:null;
                                if(appliedFilters[filter.name]['value']!=null){
                                    buildQueryVariables += '&' + filter.name + '=' + appliedFilters[filter.name]['value'];
                                    buildQueryVariables += '&' + filter.name + '_text=' + (appliedFilters[filter.name]['valueText'] || appliedFilters[filter.name]['value']);
                                }
                                
                            }
                            else
                            {
                             
                                
                                if (appliedFilters[filter.name]['value'] != '' ) {
                                    const mappedValue = Utils.couponStatus(appliedFilters[filter.name]['value']);
                                    params[filter.nameToRequest] = mappedValue;
                                    buildQueryVariables += '&' + filter.name + '=' + mappedValue;
                                    buildQueryVariables += '&' + filter.name + '_text=' + mappedValue;
                                }
                            }   
                                                     
                        }
                      
                        
                    }
                }
            });
        }
			
        if (parentID[key] != 0) {
            if (mapping[key].map) {
                if (mapping[key].map.ParentID) {
                    params[mapping[key].map.ParentID] = parentID[key];
                    buildQueryVariables += '&ParentID=' + parentID[key];
                }
            }
        }
        if (searchTerm[key] && searchTerm[key] != '') {
            params['SearchTerm'] = searchTerm[key];     
           
             
            buildQueryVariables += '&SearchTerm=' + searchTerm[key];
        }

        if (sortBy[key] && sortBy[key] != '') {
            params['OrderBy'] = sortBy[key].sortColumn;
            params['isAscending'] = sortBy[key].sortType == 'asc' ? true : false;
            buildQueryVariables += '&OrderBy=' + sortBy[key].sortColumn+"&isAscending="+(sortBy[key].sortType == 'asc' ? true : false);
        }
       
        router.replace(router.currentRoute.value.path + buildQueryVariables);
        
        return params
	}
}